/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFedtaxtable.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/fedtaxtable";

export class AutogenModelFedtaxtable<RowType extends ModelRow> extends Endpoint<RowType, RowFedtaxtableFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFedtaxtable extends ModelRow<RowFedtaxtableFields> {
	constructor(values?: Partial<RowFedtaxtableFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFedtaxtableFields {
	aftr_thrsh_med_pct: number;
	bonus_tax_rate: number;
	cash_acct: number;
	cash_acct_c: string;
	cash_acct_d: Date;
	cash_acct_n: number;
	cash_acct_r: number;
	catchup_ded_method: string;
	catchup_liab_glid: string;
	company_id: string;
	e401k_liab_glid: string;
	emp_fica_hi_pct: number;
	emp_fica_ss_pct: number;
	emplr_fed_id: string;
	emplr_fica_hi_pct: number;
	emplr_fica_ss_pct: number;
	emplr_futa_pct: number;
	enable_catchup: string;
	enable_roth: string;
	fed_wh_allowance: number;
	fed_wh_allowance_c: string;
	fed_wh_allowance_d: Date;
	fed_wh_allowance_n: number;
	fed_wh_allowance_r: number;
	fed_wh_glid: string;
	fica_hi_eliab_glid: string;
	fica_hi_exp_glid: string;
	fica_hi_rliab_glid: string;
	fica_ss_eliab_glid: string;
	fica_ss_exp_glid: string;
	fica_ss_rliab_glid: string;
	futa_exp_glid: string;
	futa_liab_glid: string;
	higher_catchup_beg_age: number;
	higher_catchup_end_age: number;
	higher_catchup_limit: number;
	higher_catchup_limit_c: string;
	higher_catchup_limit_d: Date;
	higher_catchup_limit_n: number;
	higher_catchup_limit_r: number;
	id: number;
	m_401k_exp_glid: string;
	m_401k_liab_glid: string;
	m_catch_exp_glid: string;
	m_catch_liab_glid: string;
	m_roth_c_exp_glid: string;
	m_roth_c_liab_glid: string;
	m_roth_exp_glid: string;
	m_roth_liab_glid: string;
	married_deductions: number;
	married_deductions_c: string;
	married_deductions_d: Date;
	married_deductions_n: number;
	married_deductions_r: number;
	max_401k_amt: number;
	max_401k_amt_c: string;
	max_401k_amt_d: Date;
	max_401k_amt_n: number;
	max_401k_amt_r: number;
	max_catchup_amt: number;
	max_catchup_amt_c: string;
	max_catchup_amt_d: Date;
	max_catchup_amt_n: number;
	max_catchup_amt_r: number;
	max_fica_hi_amt: number;
	max_fica_hi_amt_c: string;
	max_fica_hi_amt_d: Date;
	max_fica_hi_amt_n: number;
	max_fica_hi_amt_r: number;
	max_fica_ss_amt: number;
	max_fica_ss_amt_c: string;
	max_fica_ss_amt_d: Date;
	max_fica_ss_amt_n: number;
	max_fica_ss_amt_r: number;
	max_futa_amt: number;
	max_futa_amt_c: string;
	max_futa_amt_d: Date;
	max_futa_amt_n: number;
	max_futa_amt_r: number;
	max_match401kamt: number;
	max_match401kamt_c: string;
	max_match401kamt_d: Date;
	max_match401kamt_n: number;
	max_match401kamt_r: number;
	med_wage_thrshld: number;
	med_wage_thrshld_c: string;
	med_wage_thrshld_d: Date;
	med_wage_thrshld_n: number;
	med_wage_thrshld_r: number;
	otherwise_deduct_opt: number;
	otherwise_deduct_opt_c: string;
	otherwise_deduct_opt_d: Date;
	otherwise_deduct_opt_n: number;
	otherwise_deduct_opt_r: number;
	otherwise_deduct_single: number;
	otherwise_deduct_single_c: string;
	otherwise_deduct_single_d: Date;
	otherwise_deduct_single_n: number;
	otherwise_deduct_single_r: number;
	roth_c_liab_glid: string;
	roth_liab_glid: string;
	use_auto_tax_table: string;
}

